import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const ArrowLeftIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 14 12" },
        React.createElement("path", { d: "M5.99997 10.7929V6.99999H13.5C13.7761 6.99999 14 6.77613 14 6.49999V5.49999C14 5.22385 13.7761 4.99999 13.5 4.99999H5.99997V1.20708C5.99997 0.761664 5.46144 0.538594 5.14647 0.853554L0.353552 5.64641C0.158272 5.84168 0.158272 6.15829 0.353552 6.35356L5.14646 11.1464C5.46143 11.4614 5.99997 11.2383 5.99997 10.7929Z" })));
};

export { ArrowLeftIcon };
//# sourceMappingURL=ArrowLeftIcon.esm.js.map
